import React, { Component } from 'react'
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom'
import Layout from '../views/layout'

import Home from '../views/home'

export default class index extends Component {
    render() {
        return (
            <HashRouter>
                <Switch>
                    <Route exact path="/" component={Home} />
                    <Route
                        path="/"
                        render={() => {
                            // if (!token) {
                            //     return <Redirect to="/login" />;
                            // } else {
                            return <Layout />
                            // }
                        }}
                    />
                </Switch>

            </HashRouter>
        )
    }
}
